var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"icon-button",attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click', $event)}}},[(_vm.icon)?_c('Icon',{attrs:{"name":_vm.icon}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }